import { ConfigurationService } from './../../services/configuration.service';
import { Component, CSP_NONCE, OnInit, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleService, AssistantDataItem } from '../../services/modules.service';
import { EnvironmentService } from '../../services/enviroment.service';
import { environment } from '../../services/global-environment';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { I18nService } from '../../services/i18n.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { UserProfileEditComponent } from '../../conponents/user-profile-edit/user-profile-edit.component';

interface DepartmentsData {
  introduce: string;
  items: DepartmentItem[];
}

interface DepartmentItem {
  dep_introduce: string;
  dep_id: string;
  dep_name: string;
  dep_image_url: string;
  dep_content: string;
  dep_memo: string;
  dep_text: string;
  dep_bg_color: string;
  dep_font_color: string;
}

@Component({
  selector: 'app-lobby',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslatePipe, UserProfileEditComponent],
  templateUrl: './lobby.component.html',
  styleUrl: './lobby.component.scss',
})
export class LobbyComponent implements OnInit {
  AssistantDataItem: AssistantDataItem[] = [];
  ShowAssistantDataItem: AssistantDataItem[] = [];

  username = '';
  modules = '';

  lobbyinfotext = '';
  show_nopermission = false;

  show_target: 'department' | 'assistants' | '' = '';

  departments: DepartmentsData = { introduce: '', items: [] };
  depId: string = ''; // 用於存儲當前部門 ID

  // 個人資料編輯相關
  showUserProfileModal = false;


  constructor(
    private moduleservice: ModuleService,
    private router: Router, // 注入 Router
    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private i18nService: I18nService
  ) {}

  companyid = environment.companyid;


  ngOnInit() {

    console.log("show_target",this.show_target);
    console.log("departments.items",this.departments.items);


    //TODO:要改成從env來
    // 取得存在 LocalStorage 的值
    this.username = localStorage.getItem('username') || '';
    this.modules = localStorage.getItem('modules') || '';

    interface ModuleItem {
      assistantNo: string;
      permission?: string;
    }

    // console.log("this.modules",this.modules);

    var result = JSON.parse(this.modules);

    // console.log("result",result);

    var allowedAssistantNos: string[] = [];

    // console.log("result.assistantNo",result.assistantNo)

    if (this.modules.includes('assistantNo')) {
      const modulesArray: ModuleItem[] = JSON.parse(this.modules);
      // 將 modulesArray 轉成只包含 assistantNo 的字串陣列
      allowedAssistantNos = modulesArray.map((m) => m.assistantNo);
    } else {
      //要特別處理TPIC的情況
      allowedAssistantNos = JSON.parse(this.modules);
    }

    // console.log("allowedAssistantNos",allowedAssistantNos)

    // 取得大廳資訊
    this.moduleservice.get_company_and_module_setting(this.companyid).subscribe((response) => {
      if (!response) {
        console.error('未收到回應數據');
        return;
      }

      this.show_nopermission = response.show_nopermission || false;

      if (allowedAssistantNos.length === 1 && allowedAssistantNos[0] === 'ALL') {
        this.AssistantDataItem = response.lobby;
      } else {
        if (this.show_nopermission) {
          //要將title是admin的拿掉

          // 包含所有項目，但將不在權限清單中的項目 enable 設為 false，並依權限排序
          this.AssistantDataItem = response.lobby
            .map((item) => ({
              ...item,
              enable: allowedAssistantNos.includes(item.assistantNo) ? item.enable : false,
            }))
            .sort((a, b) => {
              const aHasPermission = allowedAssistantNos.includes(a.assistantNo) ? 1 : 0;
              const bHasPermission = allowedAssistantNos.includes(b.assistantNo) ? 1 : 0;
              return bHasPermission - aHasPermission;
            });

          if (allowedAssistantNos[0] != 'ALL') {
            this.AssistantDataItem = this.AssistantDataItem.filter(
              (item) => item.title.toLowerCase() !== 'admin'
            );
          }
        } else {
          // 只包含有權限的項目
          this.AssistantDataItem = response.lobby.filter((item) => allowedAssistantNos.includes(item.assistantNo));
        }
      }

      this.activatedRoute.queryParams.subscribe((params) => {
        this.depId = params['dep_id'];

        console.log("depId", this.depId);
        console.log("this.AssistantDataItem", this.AssistantDataItem);

        if (this.depId && this.AssistantDataItem.length > 0) {
          // 如果 URL 有 dep_id 參數，直接過濾顯示對應部門的助手
          this.filterAssistants(this.depId);

          // 確保每次 dep_id 變動時 lobbyinfotext 都正確設定
          if (this.departments.items && this.departments.items.length > 0) {
            this.lobbyinfotext = this.departments.items.find((item) => item.dep_id == this.depId)?.dep_introduce || '';
          } else if (response.departments && response.departments.items) {
            // fallback: 若 this.departments.items 為空，嘗試用 response.departments
            this.lobbyinfotext = response.departments.items.find((item) => item.dep_id == this.depId)?.dep_introduce || '';
          } else {
            this.lobbyinfotext = '';
          }
        } else if (response.departments) {
          this.show_target = 'department';
          this.departments = response.departments as DepartmentsData;
          
          // 過濾掉沒有任何可用 AI 助手的部門
          this.departments.items = this.departments.items.filter(department => {
            // 檢查該部門是否有用戶可以訪問的 AI 助手
            const hasAccessibleAssistants = this.AssistantDataItem.some(assistant => 
              assistant.dep_id === department.dep_id && 
              assistant.enable !== false
            );
            return hasAccessibleAssistants;
          });
          
          // 如果所有部門都被過濾掉了，則直接顯示助手列表
          if (this.departments.items.length === 0) {
            this.show_target = 'assistants';
            this.ShowAssistantDataItem = this.AssistantDataItem;
            this.lobbyinfotext = '';
          } else {
            this.lobbyinfotext = this.departments.introduce || '';
          }
        } else {
          this.show_target = 'assistants';
          this.ShowAssistantDataItem = this.AssistantDataItem;
          this.lobbyinfotext = '';
        }

        console.log("this.show_target", this.show_target);
      });
    });
  }

  currentDepartmentId: string = ''; // Add this property to your component class

  filterAssistants(dep_id: string) {
    this.currentDepartmentId = dep_id; // Store the current department ID
    this.ShowAssistantDataItem = this.AssistantDataItem.filter((item) => item.dep_id == dep_id);
    this.show_target = 'assistants';

    this.lobbyinfotext = this.departments.items.find((item) => item.dep_id == dep_id)?.dep_introduce || '';

    // 更新 URL，添加 dep_id 參數，不重新加載頁面
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { dep_id: dep_id },
      queryParamsHandling: 'merge', // 保留其他現有的查詢參數
      skipLocationChange: false, // 確保 URL 更新
    });
  }

  gotoAI(assistantid: string, depId: string) {
    // Navigate to assistant page with both assistant ID and department ID
    this.router.navigate(['/assistant'], {
      queryParams: {
        id: assistantid,
        dep_id: depId,
      },
    });
  }

  backToDepartments() {
    this.show_target = 'department';

    // 移除 URL 中的 dep_id 參數
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { dep_id: null },
      queryParamsHandling: 'merge',
      skipLocationChange: false,
    });
  }

  logout() {
    // 清除所有認證資料
    this.authService.clearToken();

    // 清除 localStorage 中的其他用戶資料
    localStorage.removeItem('username');
    localStorage.removeItem('modules');
    localStorage.removeItem('token');

    // 導向登入頁面
    this.router.navigate(['/login']);
  }

  // 個人資料編輯相關方法
  openUserProfile() {
    this.showUserProfileModal = true;
  }

  closeUserProfile() {
    this.showUserProfileModal = false;
  }

  onProfileUpdated() {
    console.log('Profile updated successfully');
    // 可以在這裡添加其他需要在個人資料更新後執行的邏輯
  }
}
